import React, {useState, useEffect} from 'react'
import './SearchFiles.css'

// Other Imports:
import { useStateValue } from '../../utils/Provider/StateProvider';
import DisplayIndividualPerson from '../../components/DisplayIndividualPerson';


function SearchFiles(props) {
    
    const [{user, myfamily, myrelative }] = useStateValue();

    // const [searchText, setSearchText] = useState('')
    const [searchResult, setSearchResult] = useState("");

    // TO transfer Information:
    const [displayIndividual, setDisplayIndividual] = useState(false)
    const [transferIndividual, setTransferIndividual] = useState("")


    useEffect(() => {
        
            var text = props.text
            // Search by: FAMILY NAME, NAME, PERSON ID, CALL HIM
            var splitText = text.split('-')
            const result = []
    
            if((splitText.length<=3) && (splitText[1]>=0) && (splitText[2]>=0)){
                // PERSON ID
                try {
                    const val = myrelative[splitText[1]].person_data[splitText[2]]
                    const obj = {
                                    'type': 'by Person ID',
                                    'details': val, 
                                    'name': val.name
                                }
                    result.push(obj)
                } catch (e) {
                    console.log(e.message)
                }
            }
    
            // element.name.toLowerCase().includes(e.toLowerCase())
            Object.keys(myrelative).map(item => {

                
    
                if(myrelative[item].uuid.toLowerCase().includes(text.toLowerCase())){
                    const obj = {
                        'type': 'by Family ID',
                        'details': myrelative[item].person_data , 
                        'name': myrelative[item].uuid,
                        'hint': myrelative[item].person_data[0].family_name
                    }
    
                    result.push(obj)
                }
    
                myrelative[item].person_data.map((person, index) => {
                    if(person.name.toLowerCase().includes(text.toLowerCase())){
                        // Found Name MAtching:
                        console.log("Matched name >>", person.name)
                        const obj = {
                            'type': 'by Person Name',
                            'details': person , 
                            'name': person.name,
                            
                        }
    
                        result.push(obj)
                        console.log(result)
                    }
    
                    if(person.call_him.toLowerCase().includes(text.toLowerCase())){
                        // Found call Him MAtching:
                        console.log("Matched I call Him >>", person.call_him)
                        const obj = {
                            'type': 'by what you call',
                            'details': person , 
                            'name': person.name,
                            'hint' : `call him ${person.call_him}`
                            
                        }
    
                        result.push(obj)
                    }

                    if(person.call_him === 'custom'){
                        if(person.custom_call_him.toLowerCase().includes(text.toLowerCase())){
                            console.log("Matched I call Him >>", person.call_him)
                            const obj = {
                                'type': 'by what you call',
                                'details': person , 
                                'name': person.name,
                                'hint' : `call him ${person.call_him}`
                                
                            }
        
                            result.push(obj)
                        }
                    }
    
                })
                
            })
    
            Object.keys(myfamily).map(item => {
    
                // Matched Family ID >>
                if(myfamily[item].uuid.toLowerCase().includes(text)){
                    console.log("Matched Family ID >>", myfamily[item].uuid)
                    const obj = {
                        'type': 'by Person ID',
                        'details': myfamily[item] , 
                        'name': myfamily[item].uuid,
                        'hint': myfamily[item].name                    
                    }
    
                    result.push(obj)
                }
    
                // Matched Family Person Names
                if(myfamily[item].name.toLowerCase().includes(text)){
                    console.log("Matched Family Person Names >>", myfamily[item].name)
                    const obj = {
                        'type': 'by Person Name',
                        'details': myfamily[item] , 
                        'name': myfamily[item].name,                   
                    }
    
                    result.push(obj)
                }
    
                // Matched Family call Him 
                if(myfamily[item].call_him.toLowerCase().includes(text)){
                    // console.log("Matched Family call Him >>", myfamily[item].call_him)
                    const obj = {
                        'type': 'by what you call',
                        'details': myfamily[item] , 
                        'name': myfamily[item].name,
                        'hint': `call him ${myfamily[item].call_him}`
                    }
    
                    result.push(obj)
                }
            })
    
            // Push All the Result to setSearchResult State:
            setSearchResult(result)
    
        
    }, [props.text])

  return (
    <div className='searching_result_component searching_result_component_mobile'>
                {/* <button onClick={() => check()}>Check</button> */}
                <div className='searching_result_component_head_container'>
                    <p className='search_text_bold '>Searching resullts for: {props.text}</p>
                    <i class='fa fa-times' onClick={() => props.handleClear()}></i>
                </div>

                <div className='apply_search_scroll'>
                {props.text ?

                    searchResult.length !== 0 ? 
                        searchResult.map(i => (
                            <div className='searching_result_component_container' onClick={() => {setTransferIndividual(i);setDisplayIndividual(true)}}>
                                <div className='searching_result_component_container_results'>
                                    <p className='search_text_bold'>{i.name}</p>
                                    <p className='search_text_hint'>- {i.type}</p>
                                </div>
                            </div>
                        ))

                        :

                        <p className='search_text_hint' style={{padding: '10px'}}>Ooops! No Results Found</p>

                    : 

                    "Some Thing went Wrong"
                }
                </div>


                {displayIndividual ? 
                    <DisplayIndividualPerson details={transferIndividual} handleClose={() => setDisplayIndividual(false)}/>
                :
                    null

                }
            </div>
  )
}

export default SearchFiles